import { docTypes } from 'utils/constants';

const optionalDocuments = [
    'distributorArgument',
    'regulatoryPack',
    'distributorImage',
    'brochureAMF',
    'advisorPresentation',
    'customerPresentation',
];

export const updateInvestmentFundDocs = payload => {
    let docPayload = {};

    optionalDocuments.forEach(document => {
        if (!payload[document]?.id && payload[document]) {
            const formData = new FormData();
            if (!payload[`${document}Id`]) {
                formData.append('files[]', payload[document]);
            } else {
                formData.append('file', payload[document]);
            }
            formData.append('type', docTypes.INVESTMENT_FUND);
            formData.append('subtype', 'fund_document');
            docPayload[document] = formData;
        }
    });

    return docPayload;
};

export const removeUnchangedDocs = payload => {
    let docPayload = { ...payload };
    const fundDocumentKeys = [
        'image',
        'fundRegulation',
        'mergedDici',
        'distributorArgument',
        'regulatoryPack',
        'advisorPresentation',
        'brochureAMF',
        'customerPresentation',
        'distributorImage',
    ];
    fundDocumentKeys.forEach(key => {
        if (payload[key] && payload[`${key}Id`] && payload[key]?.id === payload[`${key}Id`]) {
            delete docPayload[key];
        }
    });

    // only overwrite the fundDocumentKeys values
    return docPayload;
};

export const deleteInvestmentFundDocs = (payload, patchPayload) => {
    const newPayload = { ...patchPayload };
    optionalDocuments.forEach(document => {
        if (!payload[document]) {
            newPayload[document] = null;
        }
    });
    return newPayload;
};

export const createInvestmentFund = form => ({
    ...form,
    sgp: `/api/sgps/${form.sgp}`,
    promoter: `/api/promoters/${form.promoter}`,
    collectionEndDate: form.collectionEndDate.toDate(),
    taxBase: +form.taxBase,
    cutoffDays: +form.cutoffDays,
    paymentDays: +form.paymentDays,
    numberOfDecimals: +form.numberOfDecimals,
    iban: form.iban.replace(/\s/g, ''),
    maximumAdmissionFee: +form.maximumAdmissionFee,
    initialDurationCommercialization: +form.initialDurationCommercialization,
    firstInstalmentPercentage: +form.firstInstalmentPercentage,
    firstInstalmentDelay: +form.firstInstalmentDelay,
    externallyManagedBy: form.externallyManaged ? form.externallyManagedBy : undefined,
});
